import { Link } from 'react-router-dom';

export default function SmallBusinessCTA() {
  return (
    <section className="py-20 lg:py-24 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=aerial%20view%20of%20a%20vibrant%20small%20town%20main%20street%20with%20local%20shops%20and%20businesses%20at%20golden%20hour%2C%20warm%20orange%20and%20amber%20sunlight%2C%20pedestrians%20walking%2C%20colorful%20storefronts%2C%20cinematic%20wide%20angle%20photography%2C%20rich%20warm%20tones%2C%20no%20text%2C%20high%20contrast%2C%20photorealistic%2C%20beautiful%20sky&width=1920&height=700&seq=smb-cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-black/60" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 lg:px-8 text-center">
        <span className="inline-block text-sm font-semibold text-orange-400 uppercase tracking-widest mb-5">
          Ready to Grow Your Business?
        </span>
        <h2 className="text-3xl lg:text-4xl font-black text-white mb-5 leading-tight">
          Stop Guessing. Start Getting Customers with{' '}
          <span className="text-orange-400">AI Ads for Small Business</span>
        </h2>
        <p className="text-base text-stone-300 mb-8 leading-relaxed max-w-xl mx-auto">
          Join <strong className="text-white">25,000+ small business owners</strong> who use AdForge to run
          better <strong className="text-white">small business advertising</strong> — without agencies,
          without experience, and without wasting money.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
          <Link
            to="/signup"
            className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Generate Your First Ad — It&apos;s Free
          </Link>
          <Link
            to="/pricing"
            className="px-8 py-4 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            View Pricing
          </Link>
        </div>

        <p className="text-xs text-stone-400">
          No credit card required &middot; Cancel anytime
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-6">
          {[
            { icon: 'ri-facebook-circle-fill', label: 'Facebook Ads for Small Business' },
            { icon: 'ri-google-fill', label: 'Google Ads' },
            { icon: 'ri-instagram-fill', label: 'Instagram Ads' },
            { icon: 'ri-tiktok-fill', label: 'TikTok Ads' },
          ].map((p) => (
            <div key={p.label} className="flex items-center gap-2 text-stone-400">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${p.icon} text-base`} />
              </div>
              <span className="text-xs font-medium whitespace-nowrap">{p.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
